import { render } from "./DraftOrders.vue?vue&type=template&id=74277756&scoped=true"
import script from "./DraftOrders.vue?vue&type=script&lang=js"
export * from "./DraftOrders.vue?vue&type=script&lang=js"

import "./DraftOrders.vue?vue&type=style&index=0&id=74277756&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74277756"]])

export default __exports__